module.exports = __webpack_public_path__ + "media/flags/tl-ca6f895f.svg";